// extracted by mini-css-extract-plugin
module.exports = {"suggestedDishList":"_2WHfCXVWDXRetfQACv9a3","externalId":"_3f4U_Ba4SVp3FFZE7c_4xw"};